<template>
  <figure :class="alignClass">
    <div class="img-container" v-imgload>
      <img
        :alt="alt"
        :data-set="imgSet"
        :data-url="imgSrc"
        :width="this.loadedImageWidth"
        :height="this.loadedImageHeight"
        :src="placeHolder"
      />
      <font-awesome-icon class="fa-pulse" :icon="['far', 'spinner']" />
    </div>
    <figcaption>
      <span class="dateline">{{ captionDateline }}</span>{{ caption }} (Photo by {{ credit }})
    </figcaption>
  </figure>
</template>

<script>
import ImageLoader from '../directives/ImageLoader'
export default {
  name: 'StoryImage',
  data () {
    return {
      loadedImageWidth: this.alignClass === 'align centre' ? '1920' : '960',
      loadedImageHeight: this.imgHeight
    }
  },
  props: {
    alignClass: String,
    imgSet: String,
    imgSrc: String,
    imgHeight: {
      type: Number,
      default: 960
    },
    captionDateline: String,
    caption: String,
    credit: String,
    alt: String
  },
  directives: {
    imgload: ImageLoader
  },
  computed: {
    placeHolder() {
      return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${this.loadedImageWidth} ${this.loadedImageHeight}"%3E%3C/svg%3E`
    }
  }
}
</script>

<style lang="scss">

figure {
  margin: 0 0 4rem 0;
  .img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    svg {
      font-size: 1.5em;
      position: absolute;
    }
    &.loaded {
      svg {
        display: none;
      }
      img {
        opacity: 1;
        transition: opacity 0.7s, transform 1s;
      }
    }
  }
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
    border-radius: 2px;
    opacity: 0;
  }
  figcaption {
    max-width: 30em;
    margin: 0 auto;
    padding: 2rem;
    border-bottom: 1px solid darken($white, 5%);
    span.dateline {
      text-transform: uppercase;
      font-style: italic;
      font-size: 0.7em;
      display: block;
    }
    @include md {
      max-width: 26em;
      padding: 3rem;
    }
  }
  &.align {
    &.centre {
      .img-container {
        img {
          transform: translateY(1.3rem);
        }
        &.loaded {
          img {
            transform: translateY(0)
          }
        }
      }
      figcaption {
        @include md { max-width: 30em; }
      }
    }
    &.left, &.right {
      display: flex;
      align-items: center;
      margin-bottom: 4rem;
      flex-wrap: wrap;
        @include md {
          flex-wrap: nowrap;
        }
        figcaption {
          width: 100%;
          @include md { width: 44%; }
        }
        .img-container {
          width: 100%;
          @include md { width: 50%; }
            &.loaded {
              img {
                transform: translateX(0)
              }
            }
        }
    }
    &.left {
      figcaption {
        @include md { margin-left: 3%; }
      }
      .img-container {
        img {
          transform: translateX(-1.3rem);
        }
      }
    }
    &.right {
      figcaption {
        order: 2;
        @include md { order: 1; margin-right: 3%; }
      }
      .img-container {
        order: 1;
        @include md { order: 2; }
        img {
          transform: translateX(1.3rem);
        }
      }
    }
  }
}

</style>